import React from "react";
import Layout from "../common/layouts";
import { graphql } from "gatsby";
import Hero from "../homepage/components/hero";
import Card from "../homepage/components/card";
import About from "../homepage/components/about";
import Bio from "../homepage/components/bio";
import Seo from "../common/seo";

export default ({ data }) => {
  let post = data.featuredPost.edges[0].node;
  return (
    <Layout>
      <Seo
        title={"Home Page"}
        description={data.site.siteMetadata.description}
      />

      <Hero
        title={post.frontmatter.title}
        image={post.frontmatter.postImage.childImageSharp.fluid}
        to={post.frontmatter.slug}
        description={post.frontmatter.description}
      />

      <About />
      <Bio
        className="flex flex-wrap center mw9 justify-around pb3"
        src="https://i.imgur.com/yQsOCgL.gif"
        content="Bookbot listens to your child reading out loud. If there is a tricky word they mispronounce, Bookbot will highlight and say it correctly before your child can continue reading. No more guessing and getting it wrong"
        title="Listens and corrects instantly"
      />
      <Bio
        src="https://i.imgur.com/HNXCChy.gif"
        content="Sometimes we just can’t give our children as much time as we would like to. Bookbot doesn’t require parents’ supervision! Let the app work with your child on their reading skills, and you can save your energy for more fun things to do together."
        title="Interactive app that doesn't require supervision"
        imagePosition="left"
      />
      <Bio
        src="https://i.imgur.com/JOUokaI.gif"
        content="Our technology is able to assess your child’s reading level and pick books that will allow them to achieve success whilst stretching them just enough."
        title="Tailored reading levels"
      />

      <div className="flex flex-wrap center mw9 justify-around pb3">
        {data.cards.edges.map(({ node }) => (
          <Card
            title={node.frontmatter.title}
            image={node.frontmatter.postImage.childImageSharp.fluid}
            to={node.frontmatter.slug}
            description={node.frontmatter.description}
          />
        ))}
      </div>
    </Layout>
  );
};





export const query = graphql`
  query {
    featuredPost: allMarkdownRemark(
      limit: 1
      sort: { order: DESC, fields: frontmatter___date }
      filter: { frontmatter: { type: { eq: "post" } } }
    ) {
      edges {
        node {
          frontmatter {
            title
            description: metaDescription
            slug
            postImage {
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
    cards: allMarkdownRemark(
      skip: 1
      limit: 3
      sort: { order: DESC, fields: frontmatter___date }
      filter: { frontmatter: { type: { eq: "post" } } }
    ) {
      edges {
        node {
          frontmatter {
            title
            description: metaDescription
            slug
            postImage {
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
    site {
      siteMetadata {
        description
      }
    }
  }
`;
